/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/**
 * The data contained by a {@link StateSequenceChart}
 */

/**
 * Creates empty state-sequence data
 */
export function createEmptyData() {
  return {
    sequences: []
  };
}
/**
 * Returns the given data if its valid else returns empty data.
 *
 * INTERNAL USE ONLY!
 *
 * @param data
 */

export function sanitizeStateSequenceData(data) {
  const emptyData = createEmptyData(); // check start/end of entries and ensure that the entries do not overlap

  for (let sequenceIndex = 0; sequenceIndex < data.sequences.length; sequenceIndex++) {
    const stateSequenceEntries = data.sequences[sequenceIndex].entries;

    for (let entriesIndex = 0; entriesIndex < stateSequenceEntries.length; entriesIndex++) {
      const currentEntry = stateSequenceEntries[entriesIndex]; // check that start lies before end

      if (currentEntry.start > currentEntry.end) {
        // eslint-disable-next-line
        console.warn(`The start-timestamp of ${entriesIndex + 1}. entry of the ${sequenceIndex + 1} sequence is greater than the end-timestamp: ${new Date(currentEntry.start).toISOString()} > ${new Date(currentEntry.end).toISOString()}`);
        return emptyData;
      } // check that the current entry lies after the previous entry


      if (entriesIndex > 0) {
        const previousEntry = stateSequenceEntries[entriesIndex - 1];

        if (currentEntry.start < previousEntry.end) {
          // eslint-disable-next-line
          console.warn(`The start-timestamp of ${entriesIndex + 1}. entry of the ${sequenceIndex + 1} sequence is less than the end-timestamp of its predecessor: ${new Date(currentEntry.start).toISOString()} < ${new Date(previousEntry.end).toISOString()}`);
          return emptyData;
        }
      }
    }
  }

  return data;
}
/**
 * INTERNAL USE ONLY!
 */

export function computeDiscreteTimelineChartData(data) {
  return {
    series: data.sequences.map(sequence => ({
      entries: sequence.entries.map(entry => ({
        label: entry.label,
        start: entry.start,
        end: entry.end,
        status: entry.state
      }))
    }))
  };
}
/**
 * The entries for a state-sequence
 */
